// extracted by mini-css-extract-plugin
export default {"modalOverlay":"jP-z","modalContent":"kP-z","header":"lP-z","close":"mP-z"};